module.exports = __webpack_public_path__ + "img/Flag_of_the_Central_African_Republic.dbdecb38.svg";